import { CreateTeamDialog } from "@pages/members/teams/create-team-dialog";
import { useCompanyId } from "@context-providers/company-id-provider";
import { TEAM_DISPLAY_NAME } from "@src/constants/team-constants";
import { TeamEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useState } from "react";
import { useMediaQueryList } from "@hooks/use-media-query";
import { Button } from "@src/flat-ui/flat-ui-components";
// eslint-disable-next-line no-restricted-imports -- Importing types
import { FaroButtonProps } from "@faro-lotv/flat-ui";

/** Renders the create button and dialog to create team */
export function CreateTeam({
  variant = "secondary",
}: Pick<FaroButtonProps, "variant">): JSX.Element {
  const companyId = useCompanyId();
  const { trackEvent } = useTrackEvent();
  const { isScreenSmOrSmaller } = useMediaQueryList();

  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

  /** Open the dialog. */
  function onOpenDialog(): void {
    trackEvent({ name: TeamEvents.startCreateNewTeam });
    setIsDialogOpen(true);
  }

  return (
    <>
      <Button
        variant={isScreenSmOrSmaller ? "primary" : variant}
        onClick={onOpenDialog}
        sx={{ width: isScreenSmOrSmaller ? "100%" : "auto" }}
      >
        New {TEAM_DISPLAY_NAME}
      </Button>

      {/* Create project dialog */}
      <CreateTeamDialog
        companyId={companyId}
        isDialogOpen={isDialogOpen}
        onCloseDialog={() => setIsDialogOpen(false)}
      />
    </>
  );
}
